import React, { Component } from 'react';
import PropTypes from 'prop-types';
import WStorePurchaseWithTradeModal from '../WStoreModal/WStorePurchaseWithTradeModal';
import WStorePurchaseModalNew from './WStorePurchaseModalNew';
import WStoreQuestRedeemModal from './WStoreQuestRedeemModal';

class WStoreModalNew extends Component {
  render() {
    if (
      this.props.selectedItem &&
      this.props.selectedItem.classCode === 'Quest'
    ) {
      return <WStoreQuestRedeemModal {...this.props} />;
    }

    if (this.props.selectedItem && this.props.purchaseWithTrade) {
      return <WStorePurchaseWithTradeModal {...this.props} />;
    }

    return <WStorePurchaseModalNew {...this.props} />;
  }
}

WStoreModalNew.propTypes = {
  selectedItem: PropTypes.object,
  userWScore: PropTypes.number,
  patronAssets: PropTypes.any,
  onPurchase: PropTypes.func,
  purchaseWithTrade: PropTypes.bool,
  purchaseRequested: PropTypes.bool,
  purchaseConfirmation: PropTypes.bool,
  purchaseResponseMsg: PropTypes.string,
  purchaseEmailMsg: PropTypes.string,
  hidden: PropTypes.bool,
  onClose: PropTypes.func,
  preferredLocation: PropTypes.string,
  exchangeRates: PropTypes.shape({
    wscorePerNugget: PropTypes.number,
    wscorePerRuby: PropTypes.number,
    wscorePerSapphire: PropTypes.number,
    wscorePerWChip: PropTypes.number
  })
};

export default WStoreModalNew;
